import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

function useConfirmationDialog() {
    const [isOpen, setIsOpen] = useState(false)
    const [resolvePromise, setResolvePromise] = useState(null)
    const [message, setMessage] = useState('')
    const [dialogOptions, setDialogOptions] = useState({})

    const confirm = (message, options = {}) => {
        setMessage(message)
        setDialogOptions({
            title: options.title || '',
            confirmLabel: options.confirmLabel || 'Ok',
            cancelLabel: options.cancelLabel || 'Avbryt',
        })
        setIsOpen(true)

        return new Promise((resolve) => {
            setResolvePromise(() => resolve)
        })
    }

    const handleClose = (result) => {
        setIsOpen(false)
        if (resolvePromise) resolvePromise(result)
    }

    const ConfirmationDialog = () =>
        isOpen
            ? ReactDOM.createPortal(
                  <Dialog open={true}>
                      {dialogOptions.title && <DialogTitle>{dialogOptions.title}</DialogTitle>}
                      <DialogContent>{message}</DialogContent>
                      <DialogActions>
                          <Button onClick={() => handleClose(false)}>{dialogOptions.cancelLabel}</Button>
                          <Button onClick={() => handleClose(true)}>{dialogOptions.confirmLabel}</Button>
                      </DialogActions>
                  </Dialog>,
                  document.body,
              )
            : null

    return { confirm, ConfirmationDialog }
}

export default useConfirmationDialog
